import { CheckIcon } from "@phosphor-icons/react";

interface SaveAsAssetCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** e.g. "Save this image as an asset". */
  label: string;
  className?: string;
}

export function SaveAsAssetCheckbox({
  checked,
  onChange,
  label,
  className = "",
}: SaveAsAssetCheckboxProps) {
  return (
    <label
      className={`flex w-fit cursor-pointer items-center gap-3 text-sm text-[var(--text-primary)] ${className}`}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="peer sr-only"
      />
      <span
        aria-hidden="true"
        className={`flex size-6 shrink-0 items-center justify-center rounded-md border transition-colors peer-focus-visible:ring-2 peer-focus-visible:ring-[var(--accent-primary)] ${
          checked
            ? "border-[var(--accent-primary)] bg-[var(--accent-primary)]"
            : "border-[var(--accent-primary)]/50 bg-transparent"
        }`}
      >
        {checked && (
          <CheckIcon size={16} weight="bold" className="text-white" />
        )}
      </span>
      <span>{label}</span>
    </label>
  );
}
